function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

export function init(app) {
  app.ports.getObjectUrl.subscribe(dataUrl => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(dataURItoBlob(dataUrl));
    img.onload = (ev) => {
      app.ports.gotObjectUrl.send(
        { dataUrl, objectUrl, width: img.naturalWidth, height: img.naturalHeight }
      );
    }
    img.src = dataUrl;
  });

  app.ports.revokeObjectUrl.subscribe(objectUrl => {
    URL.revokeObjectURL(objectUrl);
  });

  app.ports.renderImage.subscribe(({ objectUrl, viewBox, canvasImageMatrix }) => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    canvas.width = viewBox.w;
    canvas.height = viewBox.h;
    img.onload = (ev) => {
      const ctx = canvas.getContext("2d");
      ctx.setTransform(...canvasImageMatrix);
      ctx.drawImage(img, 0, 0);
      app.ports.imageRendered.send(canvas.toDataURL());
    }
    img.onerror = (ev) => {
      console.error(JSON.stringify(ev))
    }
    img.src = objectUrl;
  });
}
